// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"4d2ed41e","74":"b1cdab8f","239":"f05fc979","378":"600dc826","453":"023d3b98","455":"e78d32d1","809":"897cda9a","977":"06689ce3"}[chunkId] + ".chunk.js";
};